import React, { useState } from 'react';
import { ImgLogoBallsGradient } from '../components/elements';
import { FlyBall } from '../components/jptr-flyball';
import './login.css';

function BoxLogin({ onLogin }) {

    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');

    const handleUser = (e) => {
        e.preventDefault();
        const user = e.target.value;
        setUser(user);
    }

    const handlePass = (e) => {
        e.preventDefault();
        const pass = e.target.value;
        setPass(pass);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (user === 'admin' && pass === 'password') {
            onLogin();
        } else {
            alert('Invalid credentials');
        }
    }; 

    return (
        <>
            <h1>Login</h1>
            <form className="flx-Vl-2" onSubmit={handleSubmit}>
                <div className='flx-Vl-05'>
                    <input
                        type="text"
                        name="username-login"
                        id="username-login"
                        placeholder="Username"
                        value={user}
                        onChange={handleUser}
                        required
                    />
                    <input
                        type="password"
                        name="password-login"
                        id="password-login"
                        placeholder="Password"
                        value={pass}
                        onChange={handlePass}
                        required
                    />
                </div>
                <div>
                    <button type="submit">Login</button>
                </div>
            </form>
        </>
    );
}

function BoxRegister({ onRegister }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [invitation, setInvitation] = useState('');
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            username: username,
            password: password,
            invitation: invitation,
            email: email
        };


        onRegister(data);
    };

    return (
        <>
            <h1>Register</h1>
            <form className="flx-Vc-2" onSubmit={handleSubmit}>
                <div className='flx-Vl-05'>
                    <input
                        type="text"
                        name="username-register"
                        id="username-register"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        name="password-register"
                        id="password-register"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <input type="text" name="code-register" id="code-register" placeholder="Invitation Code" 
                        value={invitation}
                        onChange={(e) => setInvitation(e.target.value)}
                        required />
                    <input type="email" name="email-register" id="email-register" placeholder="eMail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required />
                    <div className="flx-Hc-1">
                        <input type="checkbox" required />
                        <p>Accept Terms & Conditions.</p>
                    </div>
                </div>
                <button type="submit" style={{ marginTop: '2em' }}>Register</button>
            </form>
            <p id="reg-res"></p>
        </>
    );
}

export default function Login({ onLogin, onRegister }) {
    const [isLogin, setIsLogin] = useState(true);

    const handleToggle = () => {
        setIsLogin(!isLogin);
    };

    return (
        <>
            <FlyBall className="canvBackAni" />
            <div className="wrapper">
                <div className="boom">
                    <div className="flx-Vl-2 nully">
                        <ImgLogoBallsGradient />
                        <h1 className="headline">Welcome to Jupiter</h1>
                        <p id="boominfo">
                            There are planets with different tasks in the colorspace.cloud.
                            Jupiter specializes in the creation of links (devicelinks or abstract profiles) and their transformations.<br />
                            +++ This is a test area that is subject to change. +++<br />
                            © 2024 colorspace.cloud - All rights reserved.
                        </p>
                    </div>
                    {isLogin ? (
                        <div className='log'>
                            <BoxLogin onLogin={onLogin} />
                            <h5>
                                Not registered yet? <span className='boomlink' onClick={handleToggle}>Register here</span>
                            </h5>
                        </div>
                    ) : (
                        <div className='reg'>
                            <BoxRegister onRegister={onRegister} />
                            <h5>
                                Already registered? <span className='boomlink' onClick={handleToggle}>Login here</span>
                            </h5>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}